/**
 * Asserts that the type of `expr` is identical to type `T`.
 * @param expr - Expression that should be identical to type `T`.
 */ export const expectType = (expr)=>void expr;
export const falsy = [
  void 0,
  undefined,
  null,
  false,
  0,
  0n,
  ""
];
/**
 * Determines if the given value is truthy or not.
 * @param value The value to check.
 * @returns `true` if the value is truthy, otherwise `false`.
 * @internal
 */ export function isTruthy(it) {
  return typeof it != "undefined" && !falsy.includes(it);
}
 // #endregion Internal
//# sourceMappingURL=_internal.js.map